enum QueryKeys {
	wizard = 'wizard',
	flows = 'flows',
	flowsTheme = 'flows-theme',
	flowsMetadata = 'flows-metadata',
	screens = 'screens',
	authenticationMethods = 'authenticationMethods',
	customConnectors = 'customConnectors',
	defaultTemplates = 'defaultTemplates',
	audits = 'audits',
	analytics = 'analytics',
	accessKeys = 'accessKeys',
	tenantSSOMappings = 'tenantSSOMappings',
	roles = 'roles',
	permissions = 'permissions',
	managementKeys = 'managementKeys',
	projectSettings = 'projectSettings',
	company = 'company',
	createdProject = 'createdProject',
	tenant = 'tenant',
	tenants = 'tenants',
	users = 'users',
	user = 'user',
	adminUsers = 'admin-users'
}

export type QueryKeyArg = `${QueryKeys}`;

export default QueryKeys;
